const profile = {
    "LBL_PAGE_TITLE":"Профиль пользователя",
    "LBL_EDIT_PAGE_TITLE":"Изменить информацию пользователя",
    "LBL_PHONE":"Контактный телефон",
    "LBL_SKYPE":"Skype",
    "LBL_DOB":"Дата рождения",
    "LBL_AUDIO_ENABLED":"Звуки",
    "LBL_EMAIL":"Email",
    "LBL_PASSWORD":"Пароль",
    "LBL_LANGUAGE":"Язык",
    "LBL_GENDER":"Пол",
    "LBL_CHANGE_PASSWORD":"Изменить пароль",
    "LBL_FIRST_NAME":"Имя",
    "LBL_LAST_NAME":"Фамилия",
    "LBL_EDIT_PROFILE_HEADER":"Редактировать профиль",
    "LBL_CURRENT_PASSWORD":"Текущий пароль",
    "LBL_EMAIL_NOT_PASSED":"Проверьте адрес почты",
    "LBL_EMAIL_NOT_PASSED_DESCRIPTION":"Пожалуйста, проверьте правильность ввода адреса электронной почты",
    "LBL_NAME_NOT_PASSED":"Имя обязательно",
    "LBL_NAME_NOT_PASSED_DESCRIPTION":"Пожалуйста, укажите ваше Имя и Фамилию",
    "LBL_NEW_EMAIL":"Новый адрес электронной почты",
    "LBL_CONFIRM_NEW_EMAIL":"Подтвердите ваш новый адрес электронной почты",
    "LBL_NEW_PASSWORD":"Новый пароль",
    "LBL_CONFIRM_NEW_PASSWORD":"Подтвердите ваш новый пароль",
    "LBL_ERROR_UPDATING_PROFILE":"Не удалось обновить профиль",
    "LBL_ATTACH_SOCIAL_NETWORKS_TITLE":"Подключить социальные сети",
    "LBL_CONNECT_NETWORK":"Подключить",
    "LBL_NETWORK_CONNECTED":"Подключено",
    "LBL_COULDNT_CONNECT_NETWORK":"Профиль не подключен",
};
export default profile